/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResult
 */
export interface RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResult {
    /**
     * 
     * @type {number}
     * @memberof RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResult
     */
    updatedCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResult
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResult
     */
    message?: string | null;
}

/**
 * Check if a given object implements the RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResult interface.
 */
export function instanceOfRevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResult(value: object): value is RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResult {
    return true;
}

export function RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResultFromJSON(json: any): RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResult {
    return RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResultFromJSONTyped(json, false);
}

export function RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResult {
    if (json == null) {
        return json;
    }
    return {
        
        'updatedCount': json['updatedCount'] == null ? undefined : json['updatedCount'],
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResultToJSON(json: any): RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResult {
    return RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResultToJSONTyped(json, false);
}

export function RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResultToJSONTyped(value?: RevisdomApplicationFeaturesEntriesCommandsFixVersionPathsFixVersionPathsResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updatedCount': value['updatedCount'],
        'success': value['success'],
        'message': value['message'],
    };
}

